import React from 'react';
import { Link } from 'react-router-dom';

const SlidingMenu = ({ menuopen, handleBurgerMenu, user }) => {
  return (
    <div
      className={menuopen ? 'sliding-menu menuopen' : 'sliding-menu menuclose'}
    >
      {user && (
        <>
          <p className='sliding-menu-link'>
            <Link onClick={handleBurgerMenu} to='/dashboard/'>
              Dashboard
            </Link>
          </p>
          <p className='sliding-menu-link'>
            <Link onClick={handleBurgerMenu} to='/profile/'>
              Profile
            </Link>
          </p>
        </>
      )}
      <p className='sliding-menu-link'>
        <Link onClick={handleBurgerMenu} to='/'>
          Home
        </Link>
      </p>
      <p className='sliding-menu-link'>
        <Link onClick={handleBurgerMenu} to='/products/'>
          Products
        </Link>
      </p>
      {!user && (
        <p className='sliding-menu-link'>
          <Link onClick={handleBurgerMenu} to='/login/'>
            Login
          </Link>
        </p>
      )}
      {user && (
        <p className='sliding-menu-link'>
          <Link onClick={handleBurgerMenu} to='/logout/'>
            Logout
          </Link>
        </p>
      )}
    </div>
  );
};

export default SlidingMenu;
